<template>
  <v-container
    id="data-tables-view"
    fluid
    tag="section"
  >
    <v-col class="text-right">
      <app-btn
        class="mr-2"
        @click="installStatusDialog = true"
      >
        <v-icon>mdi-cellphone-check</v-icon> Installation Status
      </app-btn>
      <app-btn
        class="mr-2"
        @click="installQueueDialog = true"
      >
        <v-icon>mdi-tray-arrow-down</v-icon> Queue Installation
      </app-btn>
      <app-btn @click="dialog = true">
        <v-icon>mdi-account-plus-outline</v-icon> Add New App
      </app-btn>
    </v-col>
    <app-installation-queue-dialog
      v-model="installQueueDialog"
      :selected-company-id="selectedCompanyId"
    />
    <app-installation-status-dialog
      v-model="installStatusDialog"
      :selected-company-id="selectedCompanyId"
    />
    <material-card
      icon="mdi-account-group"
      icon-small
      color="primary"
      :title="selectedCompanyName + ' Apps'"
    >
      <v-card-text>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto"
          hide-details
          label="Search records"
          single-line
          style="max-width: 250px"
        />

        <v-divider class="mt-3" />

        <data-table-wrapper
          ref="dataTable"
          :headers="headers"
          :items.sync="items"
          server-side-rendering
          @load="loadData"
        >
          <template v-slot:top>
            <user-prompt
              v-model="deleteDialog"
              @confirm="deleteConfirm"
            />

            <form-dialog
              v-model="dialogUpdateApp"
              :default-value="{ title: '', type: '', autoLaunch: false, vpnConnect: false, visible: true, label: '', activity: '', packageName: ''}"
              @save="updateApp"
            >
              <template v-slot:[`form`]="{ item }">
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="item.title"
                    label="Title"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="item.label"
                    label="Label"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="item.type"
                    label="Type"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="item.packageName"
                    label="Package Name"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="item.activity"
                    label="Activity"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-switch
                    v-model="item.autoLaunch"
                    label="Auto Launch"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-switch
                    v-model="item.vpnConnect"
                    label="Vpn Connect"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-switch
                    v-model="item.visible"
                    label="Visible"
                  />
                </v-col>
              </template>
            </form-dialog>

            <v-dialog
              v-model="forceUpdateDialog"
              max-width="760px"
            >
              <v-card>
                <v-card-title class="d-block">
                  <div class="text-h5">
                    Force Update App to all devices
                  </div>
                  <div class="force-update-subtitle mt-1">
                    {{ (forceUpdateApp && (forceUpdateApp.title || forceUpdateApp.label)) || 'Selected app' }}
                  </div>
                </v-card-title>

                <v-card-text>
                  <v-container class="pa-0">
                    <v-row dense>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          :value="(forceUpdateApp && forceUpdateApp.packageName) || ''"
                          label="Package Name"
                          readonly
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          :value="(forceUpdateApp && forceUpdateApp.activity) || ''"
                          label="Activity"
                          readonly
                        />
                      </v-col>
                    </v-row>

                    <v-alert
                      dense
                      text
                      type="info"
                      class="mb-4"
                    >
                      The Force Update button stays disabled until Scripts Downloads contains an APK whose API metadata matches this package name.
                    </v-alert>

                    <div
                      class="force-update-summary pa-4 mb-4"
                      :class="{ 'force-update-summary--warning': showForceUpdateNoMatchWarning }"
                    >
                      <div class="font-weight-medium">
                        {{ forceUpdateAvailabilityMessage }}
                      </div>
                      <div class="text-caption mt-2">
                        {{ forceUpdateUploadStatusMessage }}
                      </div>
                    </div>

                    <v-alert
                      v-if="forceUpdateApkLoadError"
                      dense
                      text
                      type="warning"
                      class="mb-4"
                    >
                      {{ forceUpdateApkLoadError }}
                    </v-alert>

                    <div class="d-flex align-center justify-space-between mb-2 force-update-toolbar">
                      <div class="text-subtitle-2">
                        Scripts Downloads APKs
                      </div>
                      <v-btn
                        small
                        text
                        :loading="forceUpdateLoadingApks"
                        @click="loadForceUpdateApkOptions({ force: true })"
                      >
                        <v-icon
                          small
                          class="mr-1"
                        >
                          mdi-refresh
                        </v-icon>
                        Refresh
                      </v-btn>
                    </div>

                    <v-select
                      v-model="forceUpdateSelectedApkId"
                      :items="matchingForceUpdateApkOptions"
                      item-text="displayLabel"
                      item-value="id"
                      label="Available APK"
                      placeholder="No API-matched APK available yet"
                      :loading="forceUpdateLoadingApks"
                      :disabled="forceUpdateLoadingApks || !matchingForceUpdateApkOptions.length"
                    >
                      <template v-slot:item="{ item, on, attrs }">
                        <v-list-item
                          v-bind="attrs"
                          :class="{ 'default-version-option': isDefaultForceUpdateOption(item) }"
                          v-on="on"
                        >
                          <v-list-item-content>
                            <v-list-item-title>
                              {{ item.displayLabel }}
                              <v-chip
                                v-if="isDefaultForceUpdateOption(item)"
                                x-small
                                color="success"
                                text-color="white"
                                class="ml-2"
                              >
                                Default
                              </v-chip>
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-select>

                    <div
                      v-if="selectedForceUpdateApk"
                      class="force-update-summary pa-4 mb-4"
                    >
                      <div class="font-weight-medium">
                        {{ selectedForceUpdateApk.displayLabel }}
                      </div>
                      <div class="text-caption mt-2">
                        {{ selectedForceUpdateApk.packageName || 'Package metadata unavailable' }}
                      </div>
                      <div class="text-caption mt-2 force-update-break">
                        {{ selectedForceUpdateApk.filePathLabel }}
                      </div>
                    </div>

                    <v-file-input
                      v-model="forceUpdateUploadFile"
                      accept=".apk,application/vnd.android.package-archive,application/octet-stream"
                      label="Upload APK to Scripts Downloads"
                      prepend-icon="mdi-android"
                      show-size
                      clearable
                      :disabled="forceUpdateUploading || forceUpdateSending"
                      @change="onForceUpdateFileSelected"
                    />

                    <v-progress-linear
                      v-if="forceUpdateUploading || forceUpdateUploadProgress > 0"
                      :value="forceUpdateUploadProgress"
                      color="primary"
                      height="8"
                      rounded
                      class="mb-3"
                    />

                    <v-alert
                      v-if="forceUpdateUploadError"
                      dense
                      text
                      type="error"
                    >
                      {{ forceUpdateUploadError }}
                    </v-alert>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    text
                    :disabled="forceUpdateUploading || forceUpdateSending"
                    @click="forceUpdateDialog = false"
                  >
                    Cancel
                  </v-btn>
                  <app-btn
                    :disabled="!forceUpdateUploadFile || forceUpdateUploading || forceUpdateSending"
                    :loading="forceUpdateUploading"
                    @click="uploadForceUpdateApk"
                  >
                    Upload APK
                  </app-btn>
                  <app-btn
                    :disabled="!canTriggerForceUpdate"
                    :loading="forceUpdateSending"
                    @click="triggerForceUpdate"
                  >
                    Force Update
                  </app-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog
              v-model="defaultVersionDialog"
              max-width="560px"
            >
              <v-card>
                <v-card-title class="d-block">
                  <div class="text-h5">
                    Default App Version
                  </div>
                  <div class="force-update-subtitle mt-1">
                    {{ (defaultVersionApp && (defaultVersionApp.title || defaultVersionApp.label)) || 'Selected app' }}
                  </div>
                </v-card-title>

                <v-card-text>
                  <v-alert
                    dense
                    text
                    type="info"
                    class="mb-4"
                  >
                    Devices will install this version by default when the app is pushed, unless overridden per device.
                  </v-alert>

                  <v-alert
                    v-if="forceUpdateApkLoadError"
                    dense
                    text
                    type="warning"
                    class="mb-4"
                  >
                    {{ forceUpdateApkLoadError }}
                  </v-alert>

                  <div class="d-flex align-center justify-space-between mb-2 force-update-toolbar">
                    <div class="text-subtitle-2">
                      Scripts Downloads APKs
                    </div>
                    <v-btn
                      small
                      text
                      :loading="forceUpdateLoadingApks"
                      @click="loadForceUpdateApkOptions({ force: true })"
                    >
                      <v-icon
                        small
                        class="mr-1"
                      >
                        mdi-refresh
                      </v-icon>
                      Refresh
                    </v-btn>
                  </div>

                  <v-select
                    v-model="defaultVersionSelectedFilePathId"
                    :items="matchingDefaultVersionApkOptions"
                    item-text="displayLabel"
                    item-value="filePathId"
                    label="Default version"
                    placeholder="No default version set"
                    clearable
                    :loading="forceUpdateLoadingApks"
                    :disabled="forceUpdateLoadingApks || defaultVersionSaving"
                  />
                </v-card-text>

                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    text
                    :disabled="defaultVersionSaving"
                    @click="defaultVersionDialog = false"
                  >
                    Cancel
                  </v-btn>
                  <app-btn
                    :loading="defaultVersionSaving"
                    @click="saveDefaultVersion"
                  >
                    Save
                  </app-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog
              v-model="dialog"
              max-width="1350px"
              :fullscreen="$vuetify.breakpoint.smAndDown"
            >
              <v-card style="display: flex; flex-direction: column; height: 100%;">
                <v-card-title style="flex: 0 0 auto;">
                  <span class="text-h5">{{ formTitle }}</span>
                  <v-spacer />
                  <v-btn
                    v-if="$vuetify.breakpoint.smAndDown"
                    icon
                    @click="dialog = false"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>

                <v-card-text style="flex: 1 1 auto; overflow-y: auto;">
                  <v-container>
                    <div
                      class="d-flex align-center justify-center ma-1 mb-1"
                      style="padding: 15px 20px; border-radius: 5px; background: #f5f5f5;"
                    >
                      <v-autocomplete
                        v-model="referenceId"
                        label="Reference"
                        :items="companies"
                        item-text="pathStr"
                        item-value="id"
                        hide-details
                        @change="chooseReference"
                      />
                    </div>
                    <div
                      class="d-flex align-center justify-center ma-1 mb-1"
                      style="padding: 15px 20px; border-radius: 5px; background: #f5f5f5;"
                    >
                      <v-row>
                        <v-col
                          cols="12"
                          sm="4"
                        >
                          <v-text-field
                            v-model="editedItem.title"
                            label="Title"
                            hide-details
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="4"
                        >
                          <v-text-field
                            v-model="editedItem.label"
                            label="Label"
                            hide-details
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="4"
                        >
                          <v-text-field
                            v-model="editedItem.type"
                            label="Type"
                            hide-details
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                        >
                          <v-text-field
                            v-model="editedItem.packageName"
                            label="Package Name"
                            hide-details
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                        >
                          <v-text-field
                            v-model="editedItem.activity"
                            label="Activity"
                            hide-details
                          />
                        </v-col>
                        <!-- <v-col cols="3"> <v-text-field v-model="editedItem.folderId" label="Folder Id"
                            hide-details /></v-col>
                        <v-col cols="3"><v-text-field v-model="editedItem.folderOrder" label="Folder Order"
                            hide-details /></v-col> -->
                        <v-col
                          cols="12"
                          sm="6"
                        >
                          <dropzone
                            placeholder="Drop app icon here"
                            @drop="onFileDrop"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="4"
                        >
                          <v-switch
                            v-model="editedItem.autoLaunch"
                            label="Auto Launch"
                            hide-details
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="4"
                        >
                          <v-switch
                            v-model="editedItem.vpnConnect"
                            label="Vpn Connect"
                            hide-details
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="4"
                        >
                          <v-switch
                            v-model="editedItem.visible"
                            label="Visible"
                            hide-details
                          />
                        </v-col>

                        <v-col cols="12">
                          <app-btn @click="addNewApp">
                            Save
                          </app-btn>
                        </v-col>
                      </v-row>
                    </div>
                    <editable-table
                      :headers="headers"
                      :items="editedItems"
                    >
                      <template v-slot:[`item.icon`]="{ item }">
                        <img
                          :src="item.iconBase64"
                          class="pa-2"
                          width="50"
                          height="50"
                          style="object-fit: cover;"
                        >
                      </template>
                    </editable-table>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="close"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="save"
                  >
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>

          <template v-slot:[`item.icon`]="{ item }">
            <img
              v-if="item.icon"
              :src="$resourceUrl('/' + item.icon)"
              class="pa-2"
              width="50"
              height="50"
              style="object-fit: cover;"
            >
            <v-icon
              v-else
              class="pa-2"
              color="primary"
              size="42"
            >
              mdi-cellphone-cog
            </v-icon>
          </template>

          <template v-slot:[`item.defaultVersionName`]="{ item }">
            {{ getDefaultVersionLabel(item) }}
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              v-if="!isDefaultMyDeviceApp(item)"
              color="info"
              class="mr-2"
              @click="dialogUpdateApp.show(item, { formTitle: 'Update App' })"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              :color="item.defaultFilePathId ? 'success' : 'grey'"
              class="mr-2 force-update-action"
              :class="{ 'force-update-action--disabled': !canOpenForceUpdateDialog(item) }"
              :title="item.defaultFilePathId ? 'Change default version' : 'Choose default version'"
              @click="handleDefaultVersionAction(item)"
            >
              {{ item.defaultFilePathId ? 'mdi-star' : 'mdi-star-outline' }}
            </v-icon>
            <v-icon
              color="warning"
              class="mr-2 force-update-action"
              :class="{ 'force-update-action--disabled': !canOpenForceUpdateDialog(item) }"
              :title="getForceUpdateActionTitle(item)"
              @click="handleForceUpdateAction(item)"
            >
              mdi-update
            </v-icon>
            <v-icon
              v-if="!isDefaultMyDeviceApp(item)"
              color="error"
              @click="deleteDialog.show({ item })"
            >
              mdi-delete
            </v-icon>
            <v-icon
              v-else
              color="grey"
              title="Default app cannot be removed"
            >
              mdi-lock
            </v-icon>
          </template>
        </data-table-wrapper>
      </v-card-text>
    </material-card>
  </v-container>
</template>
<script>
  import { get } from 'vuex-pathify'
  import store from '../store'
  import defaultMyDeviceIcon from '@/assets/logo.png'
  import AppInstallationQueueDialog from './components/custom/AppInstallationQueueDialog.vue'
  import AppInstallationStatusDialog from './components/custom/AppInstallationStatusDialog.vue'

  const toastOptions = {
    position: 'topRight',
  }

  const FORCE_UPDATE_ENDPOINT = 'CompanyKioskApp/ForceUpdate'
  const ANDROID_PACKAGE_FILE_PATTERN = /\.(apk|apkm)(?=$|[?#\s])/i
  const MYDEVICE_PACKAGE_NAME = 'au.com.softclient.mydevices'
  const DEFAULT_MYDEVICE_APP_ID = '__default_mydevice_app__'
  const DEFAULT_MYDEVICE_APP = {
    id: DEFAULT_MYDEVICE_APP_ID,
    icon: '',
    title: 'MyDevice',
    label: 'MyDevice',
    type: 'Default',
    autoLaunch: false,
    vpnConnect: false,
    visible: true,
    packageName: MYDEVICE_PACKAGE_NAME,
    activity: '',
    __defaultMyDeviceApp: true,
  }

  export default {
    name: 'DataTablesView',
    components: { AppInstallationQueueDialog, AppInstallationStatusDialog },
    data: () => ({
      rules: {
        required: (value) => !!value || 'Required.',
        length15: (value) => value.length <= 15 || 'Maximum 15 characters.',
      },
      dialog: false,
      installQueueDialog: false,
      installStatusDialog: false,
      deleteDialog: null,
      dialogUpdateApp: null,
      headers: [
        { text: 'Icon', value: 'icon' },
        { text: 'Title', value: 'title' },
        { text: 'Label', value: 'label' },
        { text: 'Type', value: 'type' },
        { text: 'AutoLaunch', value: 'autoLaunch' },
        { text: 'VpnConnect', value: 'vpnConnect' },
        { text: 'Visible', value: 'visible' },
        { text: 'PackageName', value: 'packageName' },
        { text: 'Activity', value: 'activity' },
        { text: 'Default Version', value: 'defaultVersionName', sortable: false },
        { text: 'Actions', value: 'actions' },
      ],
      items: [],
      editedItem: {
        icon: '',
        iconBase64: '',
        title: '',
        label: '',
        type: '',
        autoLaunch: false,
        vpnConnect: false,
        visible: false,
        packageName: '',
        activity: '',
      },
      defaultItem: {
        icon: '',
        iconBase64: '',
        title: '',
        label: '',
        type: '',
        autoLaunch: false,
        vpnConnect: false,
        visible: false,
        packageName: '',
        activity: '',
      },
      editedIndex: -1,
      editedItems: [],
      search: undefined,
      referenceId: undefined,
      forceUpdateDialog: false,
      forceUpdateApp: null,
      forceUpdateApkOptions: [],
      forceUpdateApkLoadError: '',
      forceUpdateApkOptionsCompanyId: 0,
      forceUpdateSelectedApkId: null,
      forceUpdateUploadFile: null,
      forceUpdateUploadProgress: 0,
      forceUpdateUploadError: '',
      forceUpdateUploadMeta: null,
      forceUpdateDownloadsConfig: null,
      forceUpdateLoadingApks: false,
      forceUpdateUploading: false,
      forceUpdateSending: false,
      defaultVersionDialog: false,
      defaultVersionApp: null,
      defaultVersionSelectedFilePathId: null,
      defaultVersionSaving: false,
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Add New App' : 'Edit App'
      },
      ...get('company', ['selectedCompanyId', 'selectedCompanyName']),
      companies () {
        return store.getters['company/getCompanies']
      },
      matchingForceUpdateApkOptions () {
        const packageName = this.normalizePackageValue(this.forceUpdateApp?.packageName)

        if (!packageName) {
          return []
        }

        const options = this.forceUpdateApkOptions.filter(option =>
          this.normalizePackageValue(option.packageName) === packageName,
        )

        return this.sortWithDefaultFirst(options, this.forceUpdateApp?.defaultFilePathId)
      },
      selectedForceUpdateApk () {
        return this.matchingForceUpdateApkOptions.find(
          option => option.id === this.forceUpdateSelectedApkId,
        ) || null
      },
      matchingDefaultVersionApkOptions () {
        const packageName = this.normalizePackageValue(this.defaultVersionApp?.packageName)

        if (!packageName) {
          return []
        }

        return this.forceUpdateApkOptions.filter(option =>
          this.normalizePackageValue(option.packageName) === packageName,
        )
      },
      canTriggerForceUpdate () {
        return (!!this.forceUpdateApp?.id || this.isDefaultMyDeviceApp(this.forceUpdateApp)) &&
          !!this.selectedForceUpdateApk &&
          !this.forceUpdateUploading &&
          !this.forceUpdateSending
      },
      forceUpdateAvailabilityMessage () {
        if (!this.forceUpdateApp?.packageName) {
          return 'Add a package name to this app before forcing updates.'
        }

        if (this.forceUpdateLoadingApks) {
          return 'Checking Scripts Downloads for APK metadata...'
        }

        if (this.matchingForceUpdateApkOptions.length) {
          const count = this.matchingForceUpdateApkOptions.length
          return count === 1
            ? 'One API-matched APK is ready in Scripts Downloads.'
            : `${count} API-matched APKs are ready in Scripts Downloads.`
        }

        return `No uploaded APK metadata matched ${this.forceUpdateApp.packageName} yet. Upload one below to enable Force Update.`
      },
      showForceUpdateNoMatchWarning () {
        return !!this.forceUpdateApp?.packageName &&
          !this.forceUpdateLoadingApks &&
          !this.matchingForceUpdateApkOptions.length
      },
      forceUpdateUploadStatusMessage () {
        if (this.forceUpdateUploading) {
          return this.forceUpdateUploadProgress > 0
            ? `Uploading APK to Scripts Downloads... ${this.forceUpdateUploadProgress}%`
            : 'Uploading APK to Scripts Downloads...'
        }

        if (this.selectedForceUpdateApk) {
          const versionText = this.selectedForceUpdateApk.versionName
            ? ` (${this.selectedForceUpdateApk.versionName})`
            : ''
          return `Selected APK: ${this.selectedForceUpdateApk.name}${versionText}`
        }

        if (this.forceUpdateUploadMeta?.packageName) {
          const versionText = this.forceUpdateUploadMeta.versionName
            ? ` | Version ${this.forceUpdateUploadMeta.versionName}`
            : ''
          return `Uploaded package ${this.forceUpdateUploadMeta.packageName}${versionText}`
        }

        return 'Upload an APK and the server metadata will decide whether it matches this app package.'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      forceUpdateDialog (val) {
        if (!val) {
          this.resetForceUpdateDialog()
        }
      },
      defaultVersionDialog (val) {
        if (!val) {
          this.defaultVersionApp = null
          this.defaultVersionSelectedFilePathId = null
        }
      },
      selectedCompanyId () {
        this.$refs.dataTable.reload()
        this.resetForceUpdateDialog({ preserveApkCache: false })
        this.forceUpdateDialog = false
        this.defaultVersionDialog = false
        this.loadForceUpdateApkOptions()
      },
    },

    created () {
      if (this.selectedCompanyId) {
        this.loadForceUpdateApkOptions()
      }
    },

    methods: {
      loadData ({ page, itemsPerPage, search, callback }, companyId) {
        companyId ??= this.selectedCompanyId
        this.getCompanyApps({ page, itemsPerPage, search }, companyId).then(res => {
          const responseItems = res.data?.data?.items || []
          const totalCount = res.data?.data?.totalCount || 0
          callback(
            this.includeDefaultMyDeviceApp(responseItems, { page, search }),
            totalCount + (this.shouldShowDefaultMyDeviceApp({ items: responseItems, page, search }) ? 1 : 0),
          )
        })
      },
      getCompanyApps ({ page, itemsPerPage, search }, companyId) {
        return this.$http.post(`/CompanyKioskApp/paginated/${companyId}`, {
          pageNumber: page,
          pageSize: itemsPerPage,
          search,
        })
      },
      handleForceUpdateAction (item) {
        if (!this.canOpenForceUpdateDialog(item)) {
          this.$toast.error(this.getForceUpdateActionTitle(item), 'Error', toastOptions)
          return
        }

        this.openForceUpdateDialog(item)
      },
      canOpenForceUpdateDialog (item) {
        return !!this.selectedCompanyId && !!String(item?.packageName || '').trim()
      },
      getForceUpdateActionTitle (item) {
        if (!this.selectedCompanyId) {
          return 'Select a company before forcing updates.'
        }

        if (!String(item?.packageName || '').trim()) {
          return 'Add a package name to this app before forcing updates.'
        }

        return 'Upload or select an APK from Scripts Downloads to force this app update.'
      },
      openForceUpdateDialog (item) {
        this.resetForceUpdateDialog()
        this.forceUpdateApp = Object.assign({}, item)
        this.forceUpdateDialog = true
        this.loadForceUpdateApkOptions()
      },
      sortWithDefaultFirst (options, defaultFilePathId) {
        if (!defaultFilePathId) {
          return options
        }

        return [...options].sort((left, right) => {
          const leftIsDefault = left.filePathId === defaultFilePathId ? 1 : 0
          const rightIsDefault = right.filePathId === defaultFilePathId ? 1 : 0
          return rightIsDefault - leftIsDefault
        })
      },
      isDefaultForceUpdateOption (option) {
        return !!this.forceUpdateApp?.defaultFilePathId && option?.filePathId === this.forceUpdateApp.defaultFilePathId
      },
      getDefaultVersionLabel (item) {
        if (!item?.defaultFilePathId) {
          return 'Not set'
        }

        if (item.defaultVersionName) {
          return `${item.defaultVersionName}${item.defaultVersionCode ? ' (' + item.defaultVersionCode + ')' : ''}`
        }

        const match = this.forceUpdateApkOptions.find(
          option => option.filePathId === item.defaultFilePathId,
        )

        if (match) {
          return `${match.versionName}${match.versionCode ? ' (' + match.versionCode + ')' : ''}`
        }

        return 'Version details unavailable'
      },
      handleDefaultVersionAction (item) {
        if (!this.canOpenForceUpdateDialog(item)) {
          this.$toast.error(this.getForceUpdateActionTitle(item), 'Error', toastOptions)
          return
        }

        this.openDefaultVersionDialog(item)
      },
      openDefaultVersionDialog (item) {
        this.defaultVersionApp = Object.assign({}, item)
        this.defaultVersionSelectedFilePathId = item?.defaultFilePathId || null
        this.defaultVersionDialog = true
        this.loadForceUpdateApkOptions()
      },
      async saveDefaultVersion () {
        if (!this.defaultVersionApp) {
          return
        }

        this.defaultVersionSaving = true

        try {
          const companyKioskAppId = await this.resolveCompanyKioskAppIdForForceUpdate(this.defaultVersionApp)
          if (!companyKioskAppId) {
            this.$toast.error('Company kiosk app id was not found for this package.', 'Error', toastOptions)
            return
          }

          await this.$http.put(`/CompanyKioskApp/companies/${this.selectedCompanyId}/default-version`, {
            companyKioskAppId,
            defaultFilePathId: this.defaultVersionSelectedFilePathId || null,
          })

          const selectedApk = this.matchingDefaultVersionApkOptions.find(
            option => option.filePathId === this.defaultVersionSelectedFilePathId,
          )

          const target = this.items.find(item => item.id === companyKioskAppId)
          if (target) {
            this.$set(target, 'defaultFilePathId', this.defaultVersionSelectedFilePathId || null)
            this.$set(target, 'defaultVersionName', selectedApk?.versionName || '')
            this.$set(target, 'defaultVersionCode', selectedApk?.versionCode || 0)
          } else {
            this.$refs.dataTable?.reload()
          }

          this.$toast.success('Default version updated.', 'Success', toastOptions)
          this.defaultVersionDialog = false
        } catch (error) {
          this.$toast.error(
            error?.response?.data?.message || error?.message || 'Could not update the default version.',
            'Error',
            toastOptions,
          )
        } finally {
          this.defaultVersionSaving = false
        }
      },
      isDefaultMyDeviceApp (item) {
        return item?.id === DEFAULT_MYDEVICE_APP_ID ||
          (Boolean(item?.__defaultMyDeviceApp) && !this.hasNumericId(item?.id))
      },
      defaultMyDeviceApp () {
        return Object.assign({}, DEFAULT_MYDEVICE_APP)
      },
      defaultMyDeviceAppMatchesSearch (search) {
        const query = String(search || '').trim().toLowerCase()
        if (!query) {
          return true
        }

        return [
          DEFAULT_MYDEVICE_APP.title,
          DEFAULT_MYDEVICE_APP.label,
          DEFAULT_MYDEVICE_APP.type,
          DEFAULT_MYDEVICE_APP.packageName,
          DEFAULT_MYDEVICE_APP.activity,
        ]
          .filter(Boolean)
          .some(value => String(value).toLowerCase().includes(query))
      },
      shouldShowDefaultMyDeviceApp ({ items = [], page = 1, search } = {}) {
        return Number(page || 1) === 1 &&
          this.defaultMyDeviceAppMatchesSearch(search) &&
          !items.some(item => this.normalizePackageValue(item?.packageName) === MYDEVICE_PACKAGE_NAME)
      },
      includeDefaultMyDeviceApp (items, options = {}) {
        if (!this.shouldShowDefaultMyDeviceApp({ ...options, items })) {
          return items
        }

        return [this.defaultMyDeviceApp(), ...items]
      },
      resetForceUpdateDialog ({ preserveApkCache = true } = {}) {
        this.forceUpdateApp = null
        this.forceUpdateSelectedApkId = null
        this.forceUpdateUploadFile = null
        this.forceUpdateUploadProgress = 0
        this.forceUpdateUploadError = ''
        this.forceUpdateUploadMeta = null
        this.forceUpdateUploading = false
        this.forceUpdateSending = false

        if (!preserveApkCache) {
          this.forceUpdateApkOptions = []
          this.forceUpdateApkLoadError = ''
          this.forceUpdateApkOptionsCompanyId = 0
          this.forceUpdateDownloadsConfig = null
          this.forceUpdateLoadingApks = false
        }
      },
      normalizePackageValue (value) {
        return String(value || '')
          .trim()
          .toLowerCase()
      },
      syncSelectedForceUpdateApk () {
        const hasSelectedApk = this.matchingForceUpdateApkOptions.some(
          option => option.id === this.forceUpdateSelectedApkId,
        )

        if (!hasSelectedApk) {
          this.forceUpdateSelectedApkId = this.matchingForceUpdateApkOptions[0]?.id || null
        }
      },
      getNestedStringValue (candidate) {
        if (typeof candidate === 'string') {
          return candidate.trim()
        }

        if (candidate && typeof candidate === 'object') {
          const nestedCandidates = [
            candidate.path,
            candidate.filePath,
            candidate.fileName,
            candidate.name,
            candidate.url,
          ]

          return nestedCandidates.find(value => typeof value === 'string' && value.trim())
        }

        return ''
      },
      normalizeConfigSearchLabel (value) {
        return String(value || '')
          .trim()
          .toLowerCase()
          .replace(/[_-]+/g, ' ')
          .replace(/\s+/g, ' ')
      },
      normalizeConfigSearchPath (value) {
        return String(value || '')
          .trim()
          .toLowerCase()
          .replace(/\\/g, '/')
          .replace(/^\/+|\/+$/g, '')
          .replace(/\/+/g, '/')
      },
      scoreDownloadsConfig (config) {
        const normalizedName = this.normalizeConfigSearchLabel(config?.name)
        const normalizedPath = this.normalizeConfigSearchPath(config?.devicePath)
        const lastPathSegment = normalizedPath.split('/').filter(Boolean).pop() || ''

        let score = -1

        if (['download', 'downloads'].includes(lastPathSegment)) {
          score = Math.max(score, 100)
        }

        if (
          normalizedPath === 'download' ||
          normalizedPath === 'downloads' ||
          normalizedPath.endsWith('/download') ||
          normalizedPath.endsWith('/downloads')
        ) {
          score = Math.max(score, 95)
        }

        if (
          ['download', 'downloads', 'script download', 'script downloads', 'scripts download', 'scripts downloads']
            .includes(normalizedName)
        ) {
          score = Math.max(score, 90)
        }

        if (/\bdownloads?\b/.test(normalizedName) && /\bscripts?\b/.test(normalizedName)) {
          score = Math.max(score, 85)
        }

        if (/\bdownloads?\b/.test(normalizedName)) {
          score = Math.max(score, 75)
        }

        if (/\bdownloads?\b/.test(normalizedPath)) {
          score = Math.max(score, 70)
        }

        return score
      },
      getDownloadsSearchCompanyIds () {
        return this.selectedCompanyId ? [this.selectedCompanyId] : []
      },
      async getDeviceConfigsByCompany (companyId) {
        const response = await this.$http.get('DeviceConfig/GetDeviceConfigsByCompany', {
          params: {
            CompanyId: companyId,
          },
        })

        return Array.isArray(response.data) ? response.data : []
      },
      async findDownloadsConfigMatches () {
        const searchCompanyIds = this.getDownloadsSearchCompanyIds()
        const configResults = await Promise.all(
          searchCompanyIds.map(async (companyId) => ({
            companyId,
            configs: await this.getDeviceConfigsByCompany(companyId),
          })),
        )

        const configs = []
        const seenConfigIds = new Set()
        const matchedDownloadsConfigs = []

        configResults.forEach(({ companyId, configs: companyConfigs }, companyIndex) => {
          companyConfigs.forEach((config) => {
            if (!seenConfigIds.has(config.id)) {
              seenConfigIds.add(config.id)
              configs.push(config)
            }

            const score = this.scoreDownloadsConfig(config)
            if (score < 0) {
              return
            }

            matchedDownloadsConfigs.push({
              companyId,
              companyIndex,
              config,
              score,
            })
          })
        })

        matchedDownloadsConfigs.sort((left, right) => {
          if (right.score !== left.score) {
            return right.score - left.score
          }

          if (left.companyIndex !== right.companyIndex) {
            return left.companyIndex - right.companyIndex
          }

          return String(left.config?.name || '').localeCompare(String(right.config?.name || ''))
        })

        return {
          configs,
          downloadsConfigs: matchedDownloadsConfigs,
          downloadsConfig: matchedDownloadsConfigs[0]?.config || null,
          downloadsConfigMatch: matchedDownloadsConfigs[0] || null,
          searchCompanyIds,
        }
      },
      buildDownloadUrlFromPath (filePath) {
        const resourceBaseUrl = this.$http.defaults.baseURL.replace('api/', 'Resources/')
        const normalizedPath = String(filePath || '')
          .replace(/\\/g, '/')
          .replace(/^\/+/, '')
          .replace(/^resources\/+/i, '')

        return new URL(normalizedPath, resourceBaseUrl).toString()
      },
      resolveUploadFilePath (responseData, originalFileName) {
        const candidates = [
          responseData?.data,
          responseData?.data?.path,
          responseData?.data?.filePath,
          responseData?.data?.url,
          responseData?.filePath,
          responseData?.path,
          responseData?.fileName,
          responseData?.name,
          responseData?.url,
        ]

        for (const candidate of candidates) {
          const stringValue = this.getNestedStringValue(candidate)
          if (!stringValue) {
            continue
          }

          if (/^https?:\/\//i.test(stringValue)) {
            return stringValue
          }

          if (/^download\//i.test(stringValue)) {
            return stringValue
          }

          if (ANDROID_PACKAGE_FILE_PATTERN.test(stringValue)) {
            return `Download/${stringValue.split(/[\\/]/).pop()}`
          }
        }

        return `Download/${originalFileName}`
      },
      normalizeExistingApkOption (file) {
        const fileName = this.getNestedStringValue(file) || 'Unnamed APK'
        const resolvedPathOrUrl = this.resolveUploadFilePath(file, fileName)
        const apkSearchSource = [
          fileName,
          resolvedPathOrUrl,
          file?.filePath,
          file?.path,
        ]
          .filter(Boolean)
          .join(' ')

        if (!ANDROID_PACKAGE_FILE_PATTERN.test(apkSearchSource)) {
          return null
        }

        const downloadUrl = /^https?:\/\//i.test(resolvedPathOrUrl)
          ? resolvedPathOrUrl
          : this.buildDownloadUrlFromPath(resolvedPathOrUrl)

        return {
          id: file?.id || file?.deviceConfigFilePathId || downloadUrl,
          filePathId: file?.filePathId || file?.id || 0,
          name: fileName,
          packageName: file?.packageName || file?.package || '',
          versionName: file?.versionName || file?.version || '',
          versionCode: file?.versionCode || 0,
          isLatestForPackage: !!file?.isLatestForPackage,
          uploadedAt: file?.uploadedAt || '',
          filePathLabel: /^https?:\/\//i.test(resolvedPathOrUrl)
            ? resolvedPathOrUrl
            : resolvedPathOrUrl.replace(/^\/+/, ''),
          downloadUrl,
          deviceConfigId: file?.deviceConfigId || file?._downloadsConfigId || 0,
          deviceConfigFilePathId: file?.deviceConfigFilePathId || file?.id || 0,
          companyId: file?.companyId || file?._downloadsCompanyId || this.selectedCompanyId,
          displayLabel: (file?.versionName || file?.version)
            ? `${file.versionName || file.version} - ${fileName}`
            : fileName,
        }
      },
      sortExistingApkOptions (items) {
        return [...items].sort((left, right) => {
          if (Number(right.isLatestForPackage) !== Number(left.isLatestForPackage)) {
            return Number(right.isLatestForPackage) - Number(left.isLatestForPackage)
          }

          if (Number(right.versionCode || 0) !== Number(left.versionCode || 0)) {
            return Number(right.versionCode || 0) - Number(left.versionCode || 0)
          }

          if (String(right.uploadedAt || '') !== String(left.uploadedAt || '')) {
            return String(right.uploadedAt || '').localeCompare(String(left.uploadedAt || ''))
          }

          return left.name.localeCompare(right.name)
        })
      },
      upsertForceUpdateApkOption (option) {
        if (!option) {
          return
        }

        const dedupedItems = this.forceUpdateApkOptions.filter(
          item => item.id !== option.id && item.downloadUrl !== option.downloadUrl,
        )

        this.forceUpdateApkOptions = this.sortExistingApkOptions([option, ...dedupedItems])
        this.forceUpdateApkOptionsCompanyId = this.selectedCompanyId
        this.forceUpdateApkLoadError = ''
        this.syncSelectedForceUpdateApk()
      },
      async loadForceUpdateApkOptions ({ force = false } = {}) {
        if (
          !force &&
          this.forceUpdateApkOptionsCompanyId === this.selectedCompanyId &&
          (this.forceUpdateApkOptions.length || this.forceUpdateApkLoadError)
        ) {
          this.syncSelectedForceUpdateApk()
          return this.forceUpdateApkOptions
        }

        if (!this.selectedCompanyId) {
          this.forceUpdateApkOptions = []
          this.forceUpdateApkLoadError = 'Select a company to browse Scripts Downloads.'
          this.forceUpdateApkOptionsCompanyId = 0
          this.forceUpdateDownloadsConfig = null
          return []
        }

        this.forceUpdateLoadingApks = true
        this.forceUpdateApkLoadError = ''

        try {
          const { downloadsConfigs, downloadsConfig, downloadsConfigMatch } = await this.findDownloadsConfigMatches()

          this.forceUpdateDownloadsConfig = downloadsConfig
            ? {
              ...downloadsConfig,
              companyId: downloadsConfigMatch?.companyId || downloadsConfig.companyId || this.selectedCompanyId,
            }
            : null

          if (!downloadsConfigs.length || !downloadsConfig) {
            this.forceUpdateApkOptions = []
            this.forceUpdateApkOptionsCompanyId = this.selectedCompanyId
            this.forceUpdateApkLoadError = 'Downloads script config was not found for this company.'
            return []
          }

          const files = (
            await Promise.all(
              downloadsConfigs.map(async ({ companyId, config }) => {
                const response = await this.$http.get('DeviceConfig/GetFilePathsByDeviceConfigs', {
                  params: {
                    DeviceConfigId: config.id,
                  },
                })

                const configFiles = Array.isArray(response.data) ? response.data : []
                return configFiles.map(file => ({
                  ...file,
                  _downloadsConfigId: config.id,
                  _downloadsCompanyId: companyId || this.selectedCompanyId,
                }))
              }),
            )
          ).flat()

          const seenOptions = new Set()
          const apkOptions = this.sortExistingApkOptions(
            files
              .map(file => this.normalizeExistingApkOption(file))
              .filter((option) => {
                if (!option || seenOptions.has(option.id)) {
                  return false
                }

                seenOptions.add(option.id)
                return true
              }),
          )

          this.forceUpdateApkOptions = apkOptions
          this.forceUpdateApkOptionsCompanyId = this.selectedCompanyId
          this.forceUpdateApkLoadError = apkOptions.length
            ? ''
            : 'No uploaded APK files were found in Scripts Downloads.'
          this.syncSelectedForceUpdateApk()

          return apkOptions
        } catch (error) {
          this.forceUpdateApkOptions = []
          this.forceUpdateApkOptionsCompanyId = this.selectedCompanyId
          this.forceUpdateApkLoadError = 'We could not load APK files from Scripts Downloads right now.'
          console.error('[CompanyApps] Failed to load Scripts APK files', {
            selectedCompanyId: this.selectedCompanyId,
            errorResponse: error?.response?.data,
            errorStatus: error?.response?.status,
            errorMessage: error?.message,
          })
          return []
        } finally {
          this.forceUpdateLoadingApks = false
        }
      },
      async onForceUpdateFileSelected (file) {
        this.forceUpdateUploadError = ''
        this.forceUpdateUploadProgress = 0
        this.forceUpdateUploadMeta = null

        if (!file) {

        }
      },
      async uploadForceUpdateApk () {
        if (!this.forceUpdateUploadFile) {
          this.$toast.error('Select an APK file to upload.', 'Error', toastOptions)
          return
        }

        this.forceUpdateUploadError = ''
        this.forceUpdateUploadProgress = 0

        try {
          let downloadsConfig = this.forceUpdateDownloadsConfig

          if (!downloadsConfig) {
            await this.loadForceUpdateApkOptions({ force: true })
            downloadsConfig = this.forceUpdateDownloadsConfig
          }

          if (!downloadsConfig) {
            this.forceUpdateUploadError = 'Downloads script config was not found for this company.'
            this.$toast.error(this.forceUpdateUploadError, 'Error', toastOptions)
            return
          }

          this.forceUpdateUploading = true

          const formData = new FormData()
          formData.append('name', this.forceUpdateUploadFile.name)
          formData.append('configType', 1)
          formData.append('deviceConfigId', downloadsConfig.id)
          formData.append('companyId', downloadsConfig.companyId || this.selectedCompanyId)
          formData.append('file', this.forceUpdateUploadFile, this.forceUpdateUploadFile.name)

          const response = await this.$http.post('DeviceConfig/AddFilesToConfig', formData, {
            onUploadProgress: (progressEvent) => {
              if (progressEvent.total) {
                this.forceUpdateUploadProgress = Math.min(
                  100,
                  Math.round((progressEvent.loaded * 100) / progressEvent.total),
                )
              }
            },
          })

          if (response?.data?.success !== true) {
            this.forceUpdateUploadError =
              response?.data?.message ||
              'The Scripts upload API rejected the APK.'
            this.$toast.error(this.forceUpdateUploadError, 'Error', toastOptions)
            return
          }

          const uploadData = response?.data?.data || {}
          const uploadedPathOrUrl = this.resolveUploadFilePath(response.data, this.forceUpdateUploadFile.name)
          const uploadedOption = this.normalizeExistingApkOption({
            ...uploadData,
            id: uploadData?.id || uploadData?.deviceConfigFilePathId,
            name: uploadData?.name || this.forceUpdateUploadFile.name,
            filePath: uploadedPathOrUrl,
            deviceConfigId: downloadsConfig.id,
            deviceConfigFilePathId:
              uploadData?.deviceConfigFilePathId ||
              uploadData?.id,
            companyId: downloadsConfig.companyId || this.selectedCompanyId,
          })

          this.forceUpdateUploadMeta = {
            packageName: uploadData?.packageName || '',
            versionName: uploadData?.versionName || '',
          }
          this.forceUpdateUploadProgress = 100
          this.forceUpdateUploadFile = null
          this.upsertForceUpdateApkOption(uploadedOption)
          if (
            this.normalizePackageValue(uploadedOption?.packageName) ===
            this.normalizePackageValue(this.forceUpdateApp?.packageName)
          ) {
            this.forceUpdateSelectedApkId = uploadedOption?.id || this.forceUpdateSelectedApkId
          }
          this.$toast.success(
            response?.data?.message || 'APK uploaded to Scripts Downloads successfully.',
            'Success',
            toastOptions,
          )
        } catch (error) {
          this.forceUpdateUploadError =
            error?.response?.data?.message ||
            error?.message ||
            'We could not upload the APK to Scripts Downloads.'
          this.$toast.error(this.forceUpdateUploadError, 'Error', toastOptions)
        } finally {
          this.forceUpdateUploading = false
        }
      },
      async postForceUpdateRequest (payload) {
        return this.$http.post(FORCE_UPDATE_ENDPOINT, payload, {
          params: {
            id: payload.companyKioskAppId,
            appId: payload.appId,
            companyKioskAppId: payload.companyKioskAppId,
            companyId: payload.companyId,
            packageName: payload.packageName,
            deviceConfigFilePathId: payload.deviceConfigFilePathId,
          },
        })
      },
      hasNumericId (value) {
        return Number.isFinite(Number(value)) && Number(value) > 0
      },
      async findCompanyKioskAppByPackageName (packageName, { search = '' } = {}) {
        const normalizedPackageName = this.normalizePackageValue(packageName)
        let page = 1
        const pageSize = 200
        let totalCount = 0

        while (page <= 10) {
          const response = await this.getCompanyApps({
            page,
            itemsPerPage: pageSize,
            search,
          }, this.selectedCompanyId)
          const result = response?.data?.data
          const items = Array.isArray(result?.items) ? result.items : []
          const match = items.find(item =>
            this.normalizePackageValue(item?.packageName) === normalizedPackageName &&
            this.hasNumericId(item?.id),
          )

          if (match) {
            return match
          }

          totalCount = Number(result?.totalCount || items.length)
          if (!items.length || page * pageSize >= totalCount) {
            break
          }

          page += 1
        }

        return null
      },
      async resolveCompanyKioskAppIdForForceUpdate (app) {
        if (this.hasNumericId(app?.id)) {
          return Number(app.id)
        }

        const packageName = this.normalizePackageValue(app?.packageName)
        if (!packageName || !this.selectedCompanyId) {
          return 0
        }

        const existingApp = await this.findCompanyKioskAppByPackageName(app?.packageName, {
          search: app?.packageName || '',
        }) || await this.findCompanyKioskAppByPackageName(app?.packageName)
        if (existingApp) {
          this.forceUpdateApp = {
            ...this.forceUpdateApp,
            ...existingApp,
            __defaultMyDeviceApp: false,
          }
          return Number(existingApp.id)
        }

        if (this.isDefaultMyDeviceApp(app)) {
          return this.createDefaultMyDeviceAppForForceUpdate()
        }

        return 0
      },
      appendKioskAppFormData (formData, app, index) {
        formData.append(`KioskApps[${index}].type`, app.type || '')
        formData.append(`KioskApps[${index}].autoLaunch`, !!app.autoLaunch)
        formData.append(`KioskApps[${index}].vpnConnect`, !!app.vpnConnect)
        formData.append(`KioskApps[${index}].visible`, !!app.visible)
        formData.append(`KioskApps[${index}].label`, app.label || '')
        formData.append(`KioskApps[${index}].activity`, app.activity || '')
        formData.append(`KioskApps[${index}].folderId`, app.folderId || 0)
        formData.append(`KioskApps[${index}].title`, app.title || '')
        formData.append(`KioskApps[${index}].folderOrder`, app.folderOrder || 0)
        formData.append(`KioskApps[${index}].packageName`, app.packageName || '')
        formData.append(`KioskApps[${index}].icon`, app.icon)
      },
      getCreatedCompanyKioskApp (responseData) {
        const data = responseData?.data
        if (Array.isArray(data)) {
          return data.find(app => this.hasNumericId(app?.id)) || null
        }

        return this.hasNumericId(data?.id) ? data : null
      },
      async getDefaultMyDeviceIconFile () {
        const response = await fetch(defaultMyDeviceIcon)
        const blob = await response.blob()
        return new File([blob], 'mydevice.png', { type: blob.type || 'image/png' })
      },
      async createDefaultMyDeviceAppForForceUpdate () {
        const defaultApp = {
          ...this.defaultMyDeviceApp(),
          icon: await this.getDefaultMyDeviceIconFile(),
        }
        const formData = new FormData()
        this.appendKioskAppFormData(formData, defaultApp, 0)

        const response = await this.$http.post(`/CompanyKioskApp/${this.selectedCompanyId}`, formData)
        if (response?.data?.success === false) {
          throw new Error(response?.data?.message || 'Default MyDevice app registration failed.')
        }

        const createdApp = this.getCreatedCompanyKioskApp(response?.data)
        const registeredApp = createdApp || await this.findCompanyKioskAppByPackageName(MYDEVICE_PACKAGE_NAME, {
          search: MYDEVICE_PACKAGE_NAME,
        }) || await this.findCompanyKioskAppByPackageName(MYDEVICE_PACKAGE_NAME)

        if (!registeredApp?.id) {
          throw new Error('Default MyDevice app was registered but no app id was returned.')
        }

        this.forceUpdateApp = {
          ...this.forceUpdateApp,
          ...registeredApp,
          __defaultMyDeviceApp: false,
        }

        this.$refs.dataTable?.reload()
        return Number(registeredApp.id)
      },
      async triggerForceUpdate () {
        if (!this.canTriggerForceUpdate) {
          this.$toast.error('Upload or select an API-matched APK first.', 'Error', toastOptions)
          return
        }

        const selectedApk = this.selectedForceUpdateApk

        this.forceUpdateSending = true

        try {
          const companyKioskAppId = await this.resolveCompanyKioskAppIdForForceUpdate(this.forceUpdateApp)
          if (!companyKioskAppId) {
            this.$toast.error('Company kiosk app id was not found for this package.', 'Error', toastOptions)
            return
          }

          const payload = {
            companyKioskAppId,
            appId: companyKioskAppId,
            companyId: this.selectedCompanyId,
            packageName: this.forceUpdateApp.packageName,
            deviceConfigFilePathId: selectedApk.deviceConfigFilePathId || selectedApk.id,
          }

          const response = await this.postForceUpdateRequest(payload)
          const isSuccess = response?.data?.success !== false && response?.data?.isSuccess !== false

          if (!isSuccess) {
            this.$toast.error(
              response?.data?.message || 'Force update failed.',
              'Error',
              toastOptions,
            )
            return
          }

          this.$toast.success(
            response?.data?.message || 'Force update triggered successfully.',
            'Success',
            toastOptions,
          )
          this.forceUpdateDialog = false
        } catch (error) {
          this.$toast.error(
            error?.response?.data?.message ||
            error?.message ||
            'Force update failed.',
            'Error',
            toastOptions,
          )
        } finally {
          this.forceUpdateSending = false
        }
      },
      close () {
        this.editedItems = []
        this.dialog = false
      },

      save () {
        if (!this.editedItems || !this.editedItems.length) {
          return
        }

        if (this.selectedCompanyId === 0) {
          this.$toast.error('Company not found.', 'Error', {
            position: 'topRight',
          })
          return
        }

        const formData = new FormData()

        this.editedItems.forEach((app, index) => this.appendKioskAppFormData(formData, app, index))

        this.$http.post(`/CompanyKioskApp/${this.selectedCompanyId}`, formData).then((response) => {
          if (response.data.success) {
            this.$toast.success('Apps added successfully.', 'Success', {
              position: 'topRight',
            })
            this.items.unshift(...response.data.data)
          } else {
            this.$toast.error(response.data.message, 'Error', {
              position: 'topRight',
            })
          }
        })

        this.close()
      },
      addNewApp () {
        this.editedItems.unshift(this.editedItem)
        this.editedItem = Object.assign({}, this.defaultItem)
      },
      update (item) {
        if (!item.configurationId && item.configurationId === 0) {
          return
        }

        this.$http.put(`/DeviceConfiguration/${item.configurationId}`, item).then(response => {
          if (response.data.success) {
            this.$toast.success('Config updated successfully.', 'Success', {
              position: 'topRight',
            })
          } else {
            this.$toast.error(response.data.message, 'Error', {
              position: 'topRight',
            })
          }
        })
      },
      updateApp (item) {
        if (this.isDefaultMyDeviceApp(item)) {
          this.$toast.error('Default MyDevice app cannot be edited.', 'Error', {
            position: 'topRight',
          })
          return
        }

        const index = this.items.findIndex(x => x.id === item.id)
        this.$http.put(`/CompanyKioskApp/${item.id}`, item).then(response => {
          if (response.data.success) {
            this.items.splice(index, 1, response.data.data)
            this.$toast.success('App updated successfully.', 'Success', {
              position: 'topRight',
            })
          } else {
            this.$toast.error(response.data.message, 'Error', {
              position: 'topRight',
            })
          }
        })
      },
      deleteConfirm ({ item }) {
        this.remove(item)
      },
      remove (item) {
        if (this.isDefaultMyDeviceApp(item)) {
          this.$toast.error('Default MyDevice app cannot be removed.', 'Error', {
            position: 'topRight',
          })
          return
        }

        this.$http.delete(`/CompanyKioskApp?id=${item.id}`).then(response => {
          if (response.data.success) {
            this.$toast.success('App removed successfully.', 'Success', {
              position: 'topRight',
            })

            const index = this.items.indexOf(item)
            this.items.splice(index, 1)
          } else {
            this.$toast.error(response.data.message, 'Error', {
              position: 'topRight',
            })
          }
        })
      },

      chooseReference () {
        this.editedItems = []

        if (!this.referenceId || this.referenceId === 0) {
          return
        }

        this.getCompanyApps({ page: 1, itemsPerPage: 50 }, this.referenceId).then(async (res) => {
          const items = res.data?.data?.items || []
          if (items) {
            const _items = items.map(async (x) => {
              const url = this.$resourceUrl('/' + x.icon)
              const filename = x.icon?.split('/')?.slice(-1)?.[0] || ''
              const filenameWithoutGuid = filename?.split('_')?.slice(1)?.join('_') || ''
              const blob = await this.getImageBlob(url)
              console.log()

              x.iconBase64 = await this.blobToBase64(blob)
              x.icon = new File([blob], filenameWithoutGuid)
              return x
            })

            this.editedItems = await Promise.all(_items)
          }
        })
      },

      async getImageBlob (url) {
        const response = await this.$http(url, { responseType: 'blob' })
        return response.data
      },
      blobToBase64 (blob) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onloadend = () => {
            resolve(reader.result)
          }
          reader.onerror = reject
          reader.readAsDataURL(blob)
        })
      },

      async onFileDrop (file) {
        this.editedItem.icon = file
        this.editedItem.iconBase64 = await this.blobToBase64(file)
      },
    },
  }
</script>

<style scoped>
  .force-update-subtitle {
    color: rgba(0, 0, 0, 0.6);
  }

  .force-update-summary {
    background: #f5f5f5;
    border-radius: 10px;
  }

  .force-update-summary--warning {
    background: #ffebee;
    border: 1px solid #ef5350;
    color: #c62828;
  }

  .force-update-break {
    word-break: break-word;
  }

  .default-version-option {
    background: #e8f5e9;
  }

  .force-update-action {
    transition: opacity 0.2s ease;
  }

  .force-update-action--disabled {
    opacity: 0.4;
  }

  .force-update-toolbar {
    gap: 12px;
  }
</style>
